"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.runAiTurn = exports.updateVision = exports.runRogue = exports.setPlayerUsedTurn = exports.drawAll = void 0;
var rogueAanimManager_sidecar_1 = require("../anims/rogueAanimManager-sidecar");
var rogueCamera_sidecar_1 = require("../camera/rogueCamera-sidecar");
var rogueInput_1 = require("../input/rogueInput");
var rogueInput_sidecar_1 = require("../input/rogueInput-sidecar");
var rogueRunMode_sidecar_1 = require("../input/rogueRunMode-sidecar");
var rogueDungeonFeatures_sidecar_1 = require("../items/rogueDungeonFeatures-sidecar");
var rogueItems_sidecar_1 = require("../items/rogueItems-sidecar");
var rogueMaps_sidecar_1 = require("../map/rogueMaps-sidecar");
require("../monofont/rogueMonofont-sidecar");
var rogueMonsters_sidecar_1 = require("../monsters/rogueMonsters-sidecar");
var rogueGlyphs_sidecar_1 = require("../targeting/rogueGlyphs-sidecar");
var rogueCursor_sidecar_1 = require("../ui/rogueCursor-sidecar");
var rogueScreenColor_sidecar_1 = require("../ui/rogueScreenColor-sidecar");
var rogueStats_sidecar_1 = require("../ui/rogueStats-sidecar");
var rogueUiCast_sidecar_1 = require("../ui/rogueUiCast-sidecar");
var rogueUiContext_sidecar_1 = require("../ui/rogueUiContext-sidecar");
var rogueUiCreateCharacter_sidecar_1 = require("../ui/rogueUiCreateCharacter-sidecar");
var rogueUiDead_sidecar_1 = require("../ui/rogueUiDead-sidecar");
var rogueUiHelp_sidecar_1 = require("../ui/rogueUiHelp-sidecar");
var rogueUiInventory_sidecar_1 = require("../ui/rogueUiInventory-sidecar");
var rogueUiMain_1 = require("../ui/rogueUiMain");
var rogueUiMain_sidecar_1 = require("../ui/rogueUiMain-sidecar");
var rogueUiMessages_sidecar_1 = require("../ui/rogueUiMessages-sidecar");
var rogueUiStory_sidecar_1 = require("../ui/rogueUiStory-sidecar");
var rogueTester_rogue_sidecar_1 = require("./rogueTester_rogue-sidecar");
var drawAll = function () {
    rogueCamera_sidecar_1.rogueCamera.centerInScreen();
    rogueScreenColor_sidecar_1.rogueScreenColor.drawAll();
    rogueMaps_sidecar_1.rogueMaps.drawAll();
    rogueDungeonFeatures_sidecar_1.rogueDungeonFeatures.drawAll();
    rogueItems_sidecar_1.rogueItems.drawAll();
    rogueMonsters_sidecar_1.rogueMonsters.drawAll();
    rogueStats_sidecar_1.rogueStats.drawAll();
    rogueUiMain_sidecar_1.rogueUiMain.drawAll();
    rogueCursor_sidecar_1.rogueCursor.update();
    // rogueGlyphs.writeDialog(
    //   5,
    //   5,
    //   20,
    //   10,
    //   'Title!',
    //   'some long text will go here and it should wrap with our dialog!!!',
    // )
    rogueGlyphs_sidecar_1.rogueGlyphs.drawAll();
    // rogueMonofont.drawAll()
};
exports.drawAll = drawAll;
var _playerUsedTurn = false;
var setPlayerUsedTurn = function () {
    _playerUsedTurn = true;
};
exports.setPlayerUsedTurn = setPlayerUsedTurn;
var runRogue = function () {
    rogueInput_sidecar_1.rogueInput.update();
    var p = rogueMonsters_sidecar_1.rogueMonsters.getPlayer();
    if (!p || p.isDead) {
        rogueUiDead_sidecar_1.rogueUiDead.open();
    }
    else {
        rogueUiDead_sidecar_1.rogueUiDead.close();
    }
    if (rogueAanimManager_sidecar_1.rogueAanimManager.update()) {
        return;
    }
    var command = rogueInput_sidecar_1.rogueInput.getAndEatNextInputCommand();
    if (command === rogueInput_sidecar_1.rogueInput.EInputCommand.none) {
        rogueRunMode_sidecar_1.rogueRunMode.update(); // Maybe get a new input command
        command = rogueInput_sidecar_1.rogueInput.getAndEatNextInputCommand();
    }
    if (command === rogueInput_sidecar_1.rogueInput.EInputCommand.none && !_playerUsedTurn) {
        return;
    }
    if (command === rogueInput_sidecar_1.rogueInput.EInputCommand.zoomIn) {
        rogueCamera_sidecar_1.rogueCamera.setZoomOffset(1);
    }
    if (command === rogueInput_sidecar_1.rogueInput.EInputCommand.zoomOut) {
        rogueCamera_sidecar_1.rogueCamera.setZoomOffset(-1);
    }
    if (rogueCursor_sidecar_1.rogueCursor.get().mode !== rogueCursor_sidecar_1.rogueCursor.ERogueTargetMode.none) {
        if (command === rogueInput_sidecar_1.rogueInput.EInputCommand.select) {
            rogueCursor_sidecar_1.rogueCursor.activateTarget();
        }
        if (command === rogueInput_sidecar_1.rogueInput.EInputCommand.cancel) {
            rogueCursor_sidecar_1.rogueCursor.setTargetMode(rogueCursor_sidecar_1.rogueCursor.ERogueTargetMode.none);
        }
        // Move target
        if (command === rogueInput_sidecar_1.rogueInput.EInputCommand.moveLeft) {
            rogueCursor_sidecar_1.rogueCursor.moveTargetOffset(-1, 0);
        }
        if (command === rogueInput_sidecar_1.rogueInput.EInputCommand.moveRight) {
            rogueCursor_sidecar_1.rogueCursor.moveTargetOffset(1, 0);
        }
        if (command === rogueInput_sidecar_1.rogueInput.EInputCommand.moveUp) {
            rogueCursor_sidecar_1.rogueCursor.moveTargetOffset(0, -1);
        }
        if (command === rogueInput_sidecar_1.rogueInput.EInputCommand.moveDown) {
            rogueCursor_sidecar_1.rogueCursor.moveTargetOffset(0, 1);
        }
        return;
    }
    var player = rogueMonsters_sidecar_1.rogueMonsters.getPlayer();
    var executedCommand = false;
    var commandTakesNoTime = false;
    if (_playerUsedTurn) {
        executedCommand = true; // something else caused a turn to be used
        commandTakesNoTime = false;
        _playerUsedTurn = false;
        console.log('executing command from animation!');
    }
    if (!executedCommand && player) {
        var isMenuOpen = rogueUiMain_sidecar_1.rogueUiMain.isUiOpen();
        var handleOpenUi = function (cmd, action) {
            if (command === cmd) {
                (0, rogueUiMain_1.closeAllMenus)();
                action();
                executedCommand = true;
                commandTakesNoTime = true;
            }
        };
        handleOpenUi(rogueInput_1.EInputCommand.openInventory, rogueUiInventory_sidecar_1.rogueUiInventory.open);
        handleOpenUi(rogueInput_1.EInputCommand.openMessages, rogueUiMessages_sidecar_1.rogueUiMessages.open);
        handleOpenUi(rogueInput_1.EInputCommand.openHelp, rogueUiHelp_sidecar_1.rogueUiHelp.open);
        handleOpenUi(rogueInput_1.EInputCommand.openStory, rogueUiStory_sidecar_1.rogueUiStory.open);
        handleOpenUi(rogueInput_1.EInputCommand.openCastMenu, rogueUiCast_sidecar_1.rogueUiCast.open);
        handleOpenUi(rogueInput_1.EInputCommand.openContextMenu, rogueUiContext_sidecar_1.rogueUiContext.open);
        if (command === rogueInput_sidecar_1.rogueInput.EInputCommand.resetGame) {
            (0, rogueUiMain_1.closeAllMenus)();
            rogueTester_rogue_sidecar_1.rogueTester_rogue.resetGame();
            executedCommand = true;
            commandTakesNoTime = true;
        }
        if (isMenuOpen) {
            // Menu command processing
            var handleMenu = function (menu) {
                if (menu.isOpen()) {
                    if (command === rogueInput_sidecar_1.rogueInput.EInputCommand.moveUp) {
                        menu.moveSelection(-1, 0);
                        executedCommand = true;
                        commandTakesNoTime = true;
                    }
                    if (command === rogueInput_sidecar_1.rogueInput.EInputCommand.moveDown) {
                        menu.moveSelection(1, 0);
                        executedCommand = true;
                        commandTakesNoTime = true;
                    }
                    if (command === rogueInput_sidecar_1.rogueInput.EInputCommand.moveRight) {
                        menu.moveSelection(0, 1);
                        executedCommand = true;
                        commandTakesNoTime = true;
                    }
                    if (command === rogueInput_sidecar_1.rogueInput.EInputCommand.moveLeft) {
                        menu.moveSelection(0, -1);
                        executedCommand = true;
                        commandTakesNoTime = true;
                    }
                    if (command === rogueInput_sidecar_1.rogueInput.EInputCommand.cancel) {
                        executedCommand = true;
                        menu.cancel();
                        commandTakesNoTime = true;
                    }
                    if (command === rogueInput_sidecar_1.rogueInput.EInputCommand.select) {
                        executedCommand = true;
                        menu.select();
                        commandTakesNoTime = true;
                    }
                }
            };
            handleMenu(rogueUiInventory_sidecar_1.rogueUiInventory);
            handleMenu(rogueUiContext_sidecar_1.rogueUiContext);
            handleMenu(rogueUiCast_sidecar_1.rogueUiCast);
            handleMenu(rogueUiCreateCharacter_sidecar_1.rogueUiCreateCharacter);
            // if (rogueUiContext.get().isOpen) {
            //   if (command === rogueInput.EInputCommand.moveUp) {
            //     rogueUiContext.moveSelection(-1)
            //     executedCommand = true
            //     commandTakesNoTime = true
            //   }
            //   if (command === rogueInput.EInputCommand.moveDown) {
            //     rogueUiContext.moveSelection(1)
            //     executedCommand = true
            //     commandTakesNoTime = true
            //   }
            // }
            if (!executedCommand) {
                if (command === rogueInput_sidecar_1.rogueInput.EInputCommand.cancel) {
                    executedCommand = true;
                    (0, rogueUiMain_1.closeAllMenus)();
                    commandTakesNoTime = true;
                }
            }
            if (!executedCommand) {
                if (command === rogueInput_sidecar_1.rogueInput.EInputCommand.select) {
                    executedCommand = true;
                    // if (rogueUiInventory.get().isOpen) {
                    //   rogueUiInventory.select()
                    // }
                    if (rogueUiHelp_sidecar_1.rogueUiHelp.get().isOpen || rogueUiMessages_sidecar_1.rogueUiMessages.get().isOpen) {
                        rogueUiHelp_sidecar_1.rogueUiHelp.close();
                        rogueUiMessages_sidecar_1.rogueUiMessages.close();
                    }
                    // if (rogueUiContext.get().isOpen) {
                    //   rogueUiContext.select()
                    // }
                    commandTakesNoTime = true;
                }
            }
        }
        else {
            // Normal command processing
            if (command === rogueInput_sidecar_1.rogueInput.EInputCommand.moveLeft) {
                rogueMonsters_sidecar_1.rogueMonsters.tryMoveOffset(player, -1, 0);
                executedCommand = true;
            }
            if (command === rogueInput_sidecar_1.rogueInput.EInputCommand.moveRight) {
                rogueMonsters_sidecar_1.rogueMonsters.tryMoveOffset(player, 1, 0);
                executedCommand = true;
            }
            if (command === rogueInput_sidecar_1.rogueInput.EInputCommand.moveUp) {
                rogueMonsters_sidecar_1.rogueMonsters.tryMoveOffset(player, 0, -1);
                executedCommand = true;
            }
            if (command === rogueInput_sidecar_1.rogueInput.EInputCommand.moveDown) {
                rogueMonsters_sidecar_1.rogueMonsters.tryMoveOffset(player, 0, 1);
                executedCommand = true;
            }
            if (command === rogueInput_sidecar_1.rogueInput.EInputCommand.moveWait) {
                // Allow monsters to move
                executedCommand = true;
            }
        }
    }
    if (executedCommand) {
        if (!commandTakesNoTime) {
            (0, exports.runAiTurn)();
        }
        else {
            (0, exports.updateVision)();
        }
    }
};
exports.runRogue = runRogue;
var updateVision = function () {
    var player = rogueMonsters_sidecar_1.rogueMonsters.getPlayer();
    var map = rogueMaps_sidecar_1.rogueMaps.getCurrentMap();
    if (map) {
        rogueMaps_sidecar_1.rogueMaps.resetVisionToWasSeen(map);
        if (player) {
            rogueMaps_sidecar_1.rogueMaps.calculatePlayerVision(map, player);
        }
    }
};
exports.updateVision = updateVision;
var runAiTurn = function () {
    // Simulate the dungeon
    rogueMonsters_sidecar_1.rogueMonsters.runAll();
    (0, exports.updateVision)();
};
exports.runAiTurn = runAiTurn;
